module.exports = __webpack_public_path__ + "BG-03.44f76df.basis";